(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dose-quote-carousel"] && !Shopify.designMode) return;
  try {
    
  // Relocate thumbnail buttons into the actual thumbnail strip.
  document.querySelectorAll('.dose-quote-carousel__slideshow').forEach((component) => {
    const container = component.querySelector('.dose-quote-carousel__thumbnails');
    if (!container) return;

    component.querySelectorAll('[data-quote-thumbnail]').forEach((thumbnail) => {
      container.appendChild(thumbnail);
    });
  });

  // Sync with viewport logic (pause when out of view)
  document.querySelectorAll('.dose-quote-carousel__slideshow').forEach((component) => {
    customElements.upgrade(component);
    if (typeof component.pause !== 'function') return;

    const syncWithViewport = () => {
      const inViewport = component.hasAttribute('in-viewport');

      if (!inViewport && !component.paused) {
        component.pause();
        component.dataset.pausedForVisibility = 'true';
      } else if (inViewport && component.dataset.pausedForVisibility) {
        delete component.dataset.pausedForVisibility;
        component.play();
      }
    };

    syncWithViewport();

    const observer = new MutationObserver(syncWithViewport);
    observer.observe(component, { attributes: true, attributeFilter: ['in-viewport'] });
  });

  // Centralized helper to synchronize all thumbnail rings and slide visibility
  function syncThumbnailsAndSlides(component, activeIndex, options = {}) {
    const { resetActiveTimer = true } = options;
    const thumbnails = component.querySelectorAll('.dose-quote-carousel__thumbnail');
    const slides = component.querySelectorAll('.dose-quote-card');

    thumbnails.forEach((thumbnail, i) => {
      const ringProgress = thumbnail.querySelector('.dose-quote-carousel__thumbnail-ring-progress');
      if (i < activeIndex) {
        thumbnail.classList.add('dose-quote-carousel__thumbnail--completed');
        thumbnail.setAttribute('aria-selected', 'false');
        if (ringProgress) ringProgress.style.strokeDashoffset = '';
      } else if (i === activeIndex) {
        thumbnail.classList.remove('dose-quote-carousel__thumbnail--completed');
        thumbnail.setAttribute('aria-selected', 'true');
        if (resetActiveTimer && ringProgress) {
          ringProgress.style.animation = 'none';
          ringProgress.offsetHeight; // trigger reflow
          if (component.hasAttribute('paused')) {
            // No timer will run while paused (cycle ended, or user hit
            // pause), and the [paused] CSS would freeze a restarted
            // animation at zero — leaving the selected thumbnail with no
            // ring while a completed neighbor keeps its full one. Snap the
            // selected ring to fully outlined instead.
            ringProgress.style.strokeDashoffset = '0';
          } else {
            ringProgress.style.strokeDashoffset = '';
            ringProgress.style.animation = '';
          }
        }
      } else {
        thumbnail.classList.remove('dose-quote-carousel__thumbnail--completed');
        thumbnail.setAttribute('aria-selected', 'false');
        if (ringProgress) ringProgress.style.strokeDashoffset = '';
      }
    });

    if (component.classList.contains('dose-quote-carousel__slideshow--fade')) {
      slides.forEach((slide, i) => {
        slide.setAttribute('data-fade-active', i === activeIndex ? 'true' : 'false');
      });
    }
  }

  // Initialize overrides, fade state, and swipe handlers
  document.querySelectorAll('.dose-quote-carousel__slideshow--fade').forEach((component) => {
    customElements.upgrade(component);
    const slides = component.querySelectorAll('.dose-quote-card');
    if (slides.length > 0) {
      slides[0].setAttribute('data-fade-active', 'true');
      syncThumbnailsAndSlides(component, 0, { resetActiveTimer: false });
    }

    // 1. Override visibleSlides getter to fix slideshow.js IntersectionObserver sync
    Object.defineProperty(component, 'visibleSlides', {
      get: function () {
        const activeSlide = this.querySelector('.dose-quote-card[data-fade-active="true"]');
        return activeSlide ? [activeSlide] : [];
      },
    });

    // 2. Override select() to force reorder: false and handle same-slide/jump selection
    if (typeof component.select === 'function') {
      const originalSelect = component.select.bind(component);
      component.select = (input, event, options = {}) => {
        delete component.dataset.cycleEnded;

        let targetIndex = input;
        if (typeof input === 'string') targetIndex = parseInt(input, 10);
        else if (typeof input === 'object' && input && 'id' in input) {
          const targetSlide = Array.from(slides).find((s) => s.getAttribute('slide-id') === input.id);
          targetIndex = targetSlide ? Array.from(slides).indexOf(targetSlide) : component.current;
        }

        // If re-selecting the currently active slide
        if (typeof targetIndex === 'number' && targetIndex === component.current) {
          syncThumbnailsAndSlides(component, targetIndex, { resetActiveTimer: true });
          if (component.autoplay && !component.paused) {
            component.play();
          }
          return;
        }

        const result = originalSelect(input, event, { ...options, reorder: false });

        if (component.autoplay && !component.paused) {
          component.play();
        }

        return result;
      };
    }

    // 3. Override play() and suspend() to ignore native hover pausing
    if (typeof component.play === 'function') {
      if (typeof component.suspend === 'function') component.suspend();

      component.addEventListener('mouseenter', (e) => e.stopImmediatePropagation(), { capture: true });
      component.addEventListener('mouseleave', (e) => e.stopImmediatePropagation(), { capture: true });

      component.play = function (interval) {
        if (this.dataset.cycleEnded) {
          delete this.dataset.cycleEnded;
          this.select(0, undefined, { animate: false });
        }

        this.suspend();
        this.paused = false;

        const duration =
          typeof interval === 'number' && !isNaN(interval) && interval > 0 ? interval : this.autoplayInterval || 8000;

        this.customIntervalId = setInterval(() => {
          if (document.hidden) return;
          this.next();
        }, duration);
      };

      component.suspend = function () {
        clearInterval(this.customIntervalId);
        this.customIntervalId = undefined;
      };

      if (component.autoplay && !component.paused) {
        component.play();
      }
    }

    // 4. Disable native desktop drag by capturing mousedown
    const scroller = component.querySelector('slideshow-slides');
    if (scroller) {
      scroller.addEventListener('mousedown', (e) => e.stopPropagation(), { capture: true });
    }

    // 5. Mobile swipe handlers
    let touchStartX = 0;
    component.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    component.addEventListener(
      'touchend',
      (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const swipeDistance = touchStartX - touchEndX;

        if (typeof component.select === 'function' && typeof component.current === 'number') {
          if (swipeDistance > 50) {
            const nextIndex = Math.min(component.current + 1, slides.length - 1);
            if (nextIndex !== component.current) component.select(nextIndex);
          } else if (swipeDistance < -50) {
            const prevIndex = Math.max(component.current - 1, 0);
            if (prevIndex !== component.current) component.select(prevIndex);
          }
        }
      },
      { passive: true }
    );
  });

  document.addEventListener('slideshow:select', (event) => {
    const component = event.target;
    if (!(component instanceof Element) || !component.classList.contains('dose-quote-carousel__slideshow')) return;

    delete component.dataset.cycleEnded;
    syncThumbnailsAndSlides(component, event.detail.index, { resetActiveTimer: true });
  });

  // infinite: false means the carousel just stops advancing once it reaches
  // the last slide, but autoplay's own setInterval keeps quietly ticking in
  // the background (each next() call a no-op) unless told to stop. Pause
  // right when the last thumbnail's own timer ring finishes, so the ring
  // ends fully outlined and the play/pause button reflects paused state.
  document.addEventListener('animationend', (event) => {
    if (!event.target.classList?.contains('dose-quote-carousel__thumbnail-ring-progress')) return;

    const thumbnail = event.target.closest('.dose-quote-carousel__thumbnail');
    const component = event.target.closest('.dose-quote-carousel__slideshow');
    if (!thumbnail || !component || thumbnail.getAttribute('aria-selected') !== 'true') return;

    const thumbnails = component.querySelectorAll('.dose-quote-carousel__thumbnail');
    if (thumbnail === thumbnails[thumbnails.length - 1]) {
      component.dataset.cycleEnded = 'true';
      component.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
